import KitFadeView from '@omni/kit/components/KitFadeView';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import React, { ReactElement } from 'react';
import { Platform } from 'react-native';

import PlayerButton, { PlayerButtonSizes } from './PlayerButton';

interface FullscreenControlProps {
  isVisible?: boolean;
  isFullscreen?: boolean;
  toggleFullscreen?: () => void;
}

export default function FullscreenControl({
  isVisible = true,
  isFullscreen,
  toggleFullscreen,
}: FullscreenControlProps): ReactElement {
  const { t } = useTranslation('media');

  return (
    <KitFadeView
      show={isVisible}
      style={{ marginLeft: 'auto' }}
      keepElementSize
    >
      <PlayerButton
        icon={isFullscreen ? 'fullscreen-exit' : 'fullscreen'}
        onPress={() => toggleFullscreen?.()}
        size={
          Platform.OS === 'web'
            ? PlayerButtonSizes.small
            : PlayerButtonSizes.medium
        }
        frameless
        tooltipProps={{
          label: isFullscreen
            ? `${t('exitFullscreen')} (f)`
            : `${t('fullscreen')} (f)`,
          keepTooltipInside: true,
        }}
      />
    </KitFadeView>
  );
}
